// File: src/BlogPage.js
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate, useParams } from "react-router";
import { getBlogDetailsFromSlug } from "../services/writerBlog";
import { Link } from "react-router-dom";
import BlogCategory from "./BlogCategory";
import RecentPosts from "./RecentPosts";
import WebsiteBreadCrumb from "./../website/website-components/WebsiteBreadCrumb";

const BlogPage = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [blogData, setBlogData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const [blogImage, setblogImage] = useState("./web-assets/images/blog.jpg");

  useEffect(() => {
    loadData(slug);
  }, [slug]);

  const loadData = async (slug) => {
    try {
      if (slug) {
        const response = await getBlogDetailsFromSlug(slug);
        if (response.status !== 200) {
          navigate("/404");
          return;
        }
        setBlogData(response?.data?.blog);
        setCategories(response?.data?.categories || []);
        setRecentPosts(response?.data?.recent || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <Helmet>
        <title>{blogData?.title ? `${blogData.title} | HeyInterns - Blog` : 'HeyInterns Blog'}</title>
      </Helmet>
      {/* <WebsiteBreadCrumb title="Blog" subtitle={blogData?.title} /> */}

      <div>
        <div className="heading-box mb-4 pt-3">
          <h1>{blogData?.title}</h1>
        </div>
        <div className="blog-deatils-wrapper">
          <img
            src={
              blogData?.banner ||
              "https://img.freepik.com/free-photo/we-are-hiring-digital-collage_23-2149667063.jpg?semt=ais_hybrid&w=740"
            }
            alt={blogData?.title}
            className="img-fluid thumbnail-blog"
            style={{ maxHeight: "500px", width: "100%", objectFit: "cover" }}
          />
          <div className="blog-details-text">
            <div
              className="blog-editor-content"
              dangerouslySetInnerHTML={{ __html: blogData?.content }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <ul style={{ display: 'flex', gap: '16px', listStyle: 'none', padding: 0 }}>
                {blogData?.categories?.map((item, index) => (
                  <li
                    key={index}
                    style={{
                      padding: "2px 5px",
                      borderRadius: "6px",
                      border: "1px solid #ccc",
                      fontSize: "12px"
                    }}
                  >
                    <Link to={`/blog/category/${item}`} > {item.replace('-', ' ')}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPage;
